import './sass/style.scss';
import './js/app.js';

import * as components0 from '../views/components/menu/horizontal/horizontal.js'; import * as components1 from '../views/components/searchform/index.js'; import * as components2 from '../views/components/slider/basic/index.js'; let components = [components0, components1, components2];
import * as blocks0 from '../views/blocks/HeroSlider/index.js'; import * as blocks1 from '../views/blocks/HistorySlider/index.js'; import * as blocks2 from '../views/blocks/PostsSlider/index.js'; import * as blocks3 from '../views/blocks/ProductsSlider/index.js'; let blocks = [blocks0, blocks1, blocks2, blocks3];
import * as woocommerce0 from '../views/woocommerce/archive-product/archive-product.js'; import * as woocommerce1 from '../views/woocommerce/components/AddedToCartPopup/added-to-cart-popup.js'; import * as woocommerce2 from '../views/woocommerce/components/ProductGallery/product-gallery.js'; import * as woocommerce3 from '../views/woocommerce/components/SidebarCart/sidebar-cart.js'; let woocommerce = [woocommerce0, woocommerce1, woocommerce2, woocommerce3];


document.addEventListener('DOMContentLoaded', function () {
  const showMoreButton = document.getElementById('showMoreButton');
  const hiddenRows = document.querySelectorAll('.hidden-row');
  const tfoot = document.querySelector('.tiresTable tfoot');
  if (showMoreButton) {
      showMoreButton.addEventListener('click', function () {
          hiddenRows.forEach(function (row) {
              row.classList.remove('hidden-row');
          });
          showMoreButton.style.display = 'none';
          tfoot.style.display = 'none';
      });
  }
});
